import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	PostPreviewsProcedure,
	PostPreviewsProcedureParams,
	PostPreviewsProcedureResponse,
} from 'domain/usecases/private/refund/request-preview';

export class RemotePostPreviewsProcedure implements PostPreviewsProcedure {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostPreviewsProcedureResponse>,
	) {}

	async post(
		params: PostPreviewsProcedureParams,
	): Promise<PostPreviewsProcedureResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
